import React from 'react';
import { TwModal } from '@ui-component-library';

const ErrorModal = ({show, onToggle, title, message}) => {
    return <TwModal isOpen={show} className="bg-neutral-cloud neutral-charcoal p-2">
        <TwModal.Header>
            <div className="flex justify-between items-start">
                <h4 className="mb-0">{title ? title : "Oops! Något gick fel."}</h4>
                <button type="button" className="ml-auto fs-5 leading-none" onClick={() => onToggle()} aria-label="Close">&times;</button>
            </div>
        </TwModal.Header>
        <TwModal.Content>
            <p className='py-6'>{message ? message : <>Ring <a href="tel:08339944" className="font-bold primary-main">08-33 99 44</a> så hjälper vi dig vidare.</>}</p>
        </TwModal.Content>
        <TwModal.Footer>
            <div className="flex justify-end">
                <button type="button" className="n-btn btn-forest-green" onClick={() => onToggle()}>Fortsätt</button>
            </div>
        </TwModal.Footer>
    </TwModal>
}

const InfoModal = ({show, onToggle, title, message}) => {
    return <TwModal isOpen={show} className="bg-neutral-cloud neutral-charcoal p-2">
        <TwModal.Header>
            <div className="flex justify-between items-start">
                <h4 className="mb-0">{title ? title : "Information"}</h4>
                <button type="button" className="ml-auto fs-5 leading-none" onClick={() => onToggle()} aria-label="Close">&times;</button>
            </div>
        </TwModal.Header>
        <TwModal.Content>
            <p className='py-6'>{message ? message : <>Klicka på Fortsätt för att stänga rutan.</>}</p>
        </TwModal.Content>
        <TwModal.Footer>
            <div className="flex justify-end">
                <button type="button" className="n-btn btn-forest-green" onClick={() => onToggle()}>Fortsätt</button>
            </div>
        </TwModal.Footer>
    </TwModal>
}

const RegisterModal = ({show, onToggle, passwordSend}) => {
    return <TwModal isOpen={show} className="bg-neutral-cloud neutral-charcoal p-2">
        <TwModal.Header>
            <div className="flex justify-between items-start">
                <h4 className="mb-0">Välkommen till Treebula</h4>
                <button type="button" className="ml-auto fs-5 leading-none" onClick={() => onToggle()} aria-label="Close">&times;</button>
            </div>
        </TwModal.Header>
        <TwModal.Content>
            <p className="fs-6">Ditt konto är nu registrerat hos oss och du kan komma igång med att använda alla våra digitala tjänster kostnadsfritt. Jämför virkespriser, ta in anbud på avverkning och gallring, få rådgivning eller skapa en skogsbruksplan - digitalt och helt utan förbindelser.</p>
        </TwModal.Content>
        <TwModal.Footer>
            <div className="flex justify-end">
                <button type="button" className="n-btn btn-forest-green" onClick={() => onToggle()}>Stäng</button>
            </div>
        </TwModal.Footer>
    </TwModal>
}

export {ErrorModal, InfoModal, RegisterModal}
